const ColumnTypes = {
  Currency: 'Currency',
};
export default ColumnTypes;
